"use client";

import {
    FormControl,
    FormDescription,
    FormField,
    FormItem,
    FormMessage,
} from "@/shared/components/ui/form";
import { Switch } from "@/shared/components/ui/switch";
import { BaseFieldProps } from "./form-field-utils";
import { FormFieldLabel } from "./form-field-label";

export function FieldSwitch({
    name,
    label,
    description,
    className,
    labelType = "text",
    tooltipContent,
    onCheckedChange,
}: BaseFieldProps & { onCheckedChange?: (checked: boolean) => void }) {
    return (
        <FormField
            name={name}
            render={({ field }) => (
                <FormItem className={className}>
                    <FormFieldLabel label={label} labelType={labelType} tooltipContent={tooltipContent} />
                    <FormControl>
                        <Switch
                            ref={field.ref}
                            checked={!!field.value}
                            onCheckedChange={(checked) => {
                                field.onChange(checked);
                                onCheckedChange?.(checked);
                            }}
                        />
                    </FormControl>
                    {description && <FormDescription>{description}</FormDescription>}
                    <FormMessage />
                </FormItem>
            )}
        />
    );
}
